export default [
  {
    level: '1',
    code: 'Army',
    label: 'Army'
  },
  {
    level: '1',
    code: 'Air Force',
    label: 'Air Force'
  },
  {
    level: '1',
    code: 'Coast Guard',
    label: 'Coast Guard'
  },
  {
    level: '1',
    code: 'Marines',
    label: 'Marines'
  },
  {
    level: '1',
    code: 'Navy',
    label: 'Navy'
  }
]
